import { createSvgIcon, SvgIconProps } from '@mui/material';

import { FC } from 'react';

export const EsaWithdrawalRequestedIcon: FC<SvgIconProps> = createSvgIcon(
  <svg viewBox='0 0 108 148'>
    <g clipPath='url(#clip0_654_6657)'>
      <path
        d='M54.2383 41.8174V75.6156'
        stroke='#3C847F'
        strokeLinecap='square'
        strokeLinejoin='round'
        strokeWidth='1.64829'
      />
      <path
        d='M54.5156 41.3969C57.2765 33.5593 68.3654 19.5612 90.6214 26.278C87.5886 34.3875 76.1165 48.7606 54.5156 41.3969Z'
        fill='#69C89A'
        stroke='#3C847F'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='0.412073'
      />
      <path
        d='M54.1704 41.4415C45.9496 42.6571 28.3953 39.377 23.9531 16.5564C32.5407 15.4603 50.606 18.897 54.1704 41.4415Z'
        fill='#69C89A'
        stroke='#3C847F'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='0.412073'
      />
      <path
        d='M61.6914 38.2197C63.7847 36.6456 66.4921 34.8984 69.834 33.3655C74.6181 31.1692 78.9943 30.1925 82.2538 29.7393'
        fill='#69C89A'
      />
      <path
        d='M61.6914 38.2197C63.7847 36.6456 66.4921 34.8984 69.834 33.3655C74.6181 31.1692 78.9943 30.1925 82.2538 29.7393'
        stroke='#3C847F'
        strokeWidth='0.412073'
      />
      <path
        d='M31.6172 22.7217C34.2915 24.2628 37.3038 26.2367 40.4314 28.7462C43.8763 31.5112 46.6578 34.2886 48.8624 36.7692'
        fill='#69C89A'
      />
      <path
        d='M31.6172 22.7217C34.2915 24.2628 37.3038 26.2367 40.4314 28.7462C43.8763 31.5112 46.6578 34.2886 48.8624 36.7692'
        stroke='#3C847F'
        strokeWidth='0.412073'
      />
      <path
        d='M50.1281 147.934C72.4607 147.934 90.5648 129.83 90.5648 107.497C90.5648 85.1647 72.4607 67.0605 50.1281 67.0605C27.7955 67.0605 9.69141 85.1647 9.69141 107.497C9.69141 129.83 27.7955 147.934 50.1281 147.934Z'
        fill='#3C847F'
      />
      <path
        d='M54.1459 147.794C76.8744 147.794 95.2996 129.369 95.2996 106.64C95.2996 83.9115 76.8744 65.4863 54.1459 65.4863C31.4173 65.4863 12.9922 83.9115 12.9922 106.64C12.9922 129.369 31.4173 147.794 54.1459 147.794Z'
        fill='#69C89A'
        stroke='#3C847F'
        strokeWidth='0.412073'
      />
      <path
        d='M54.1471 144.065C74.816 144.065 91.5715 127.309 91.5715 106.64C91.5715 85.9713 74.816 69.2158 54.1471 69.2158C33.4781 69.2158 16.7227 85.9713 16.7227 106.64C16.7227 127.309 33.4781 144.065 54.1471 144.065Z'
        fill='#69C89A'
        stroke='#3C847F'
        strokeWidth='0.412073'
      />
      <path
        clipRule='evenodd'
        d='M77.8029 87.817C79.4677 89.3046 79.5254 91.8718 77.976 93.4336L45.7766 125.851C44.5157 127.12 42.4635 127.12 41.2026 125.851L30.3156 114.89C28.7663 113.328 28.8239 110.761 30.4887 109.274C32.0175 107.906 34.3869 108.087 35.8333 109.541L43.4731 117.231C43.4731 117.231 43.4937 117.239 43.5061 117.231L72.4583 88.0849C73.9047 86.6302 76.2741 86.4489 77.8029 87.817Z'
        fill='white'
        fillRule='evenodd'
        stroke='#3C847F'
        strokeLinecap='round'
        strokeWidth='0.412073'
      />
      <path
        d='M5.19531 48.4434V51.641'
        stroke='#3C847F'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='0.618109'
      />
      <path
        d='M5.19531 54.584V57.7817'
        stroke='#3C847F'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='0.618109'
      />
      <path
        d='M9.86153 53.1123H6.66797'
        stroke='#3C847F'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='0.618109'
      />
      <path
        d='M3.72503 53.1123H0.527344'
        stroke='#3C847F'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='0.618109'
      />
      <path
        d='M58.4922 0.30957V3.50725'
        stroke='#3C847F'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='0.618109'
      />
      <path
        d='M58.4922 6.44922V9.64278'
        stroke='#3C847F'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='0.618109'
      />
      <path
        d='M63.1625 4.97852H59.9648'
        stroke='#3C847F'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='0.618109'
      />
      <path
        d='M57.0219 4.97852H53.8242'
        stroke='#3C847F'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='0.618109'
      />
      <path
        d='M102.805 57.752V60.9496'
        stroke='#3C847F'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='0.618109'
      />
      <path
        d='M102.805 63.8926V67.0903'
        stroke='#3C847F'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='0.618109'
      />
      <path
        d='M107.475 62.4209H104.277'
        stroke='#3C847F'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='0.618109'
      />
      <path
        d='M101.334 62.4209H98.1367'
        stroke='#3C847F'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='0.618109'
      />
    </g>
    <defs>
      <clipPath id='clip0_654_6657'>
        <rect
          fill='white'
          height='148'
          transform='translate(0.21875)'
          width='107.563'
        />
      </clipPath>
    </defs>
  </svg>,
  'EsaWithdrawalRequestedIcon'
);
